module.exports = __webpack_public_path__ + "img/stepvan_driving.97845fab.svg";